import {
  Archive,
  Code,
  File,
  FileText,
  Image,
  Link as LinkIcon,
  Music,
  Presentation,
  Table,
  Video,
} from "lucide-react";

type TypeDef = {
  Icon: typeof File;
  color: string;
};

const TYPE_MAP: Record<string, TypeDef> = {
  document: { Icon: FileText, color: "#2563eb" },
  image: { Icon: Image, color: "#7c3aed" },
  video: { Icon: Video, color: "#dc2626" },
  audio: { Icon: Music, color: "#db2777" },
  spreadsheet: { Icon: Table, color: "#16a34a" },
  presentation: { Icon: Presentation, color: "#ea580c" },
  archive: { Icon: Archive, color: "#d97706" },
  code: { Icon: Code, color: "#0d9488" },
  link: { Icon: LinkIcon, color: "#6b7280" },
  other: { Icon: File, color: "#6b7280" },
};

function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function FileTypeIcon({
  fileType,
  size = 40,
}: {
  fileType: string;
  extension?: string;
  size?: number;
}) {
  const def = TYPE_MAP[fileType] ?? TYPE_MAP.other;
  const iconSize = Math.round(size * 0.5);
  return (
    <div
      className="flex items-center justify-center rounded-full shrink-0"
      style={{
        width: size,
        height: size,
        backgroundColor: hexToRgba(def.color, 0.1),
      }}
    >
      <def.Icon size={iconSize} color={def.color} />
    </div>
  );
}

export function typeColor(fileType: string): string {
  return (TYPE_MAP[fileType] ?? TYPE_MAP.other).color;
}
